module.exports = __webpack_public_path__ + "media/images/icon-heatmap-e886f2346b55cb86e323a70343764e7c.png";